import { now } from "@src/utils/dates";
import { formatDate } from "@src/utils/formatters";
import type { DateRange } from "@src/utils/types";
import type { CalendarDate, CalendarValues } from "@uselessdev/datepicker";
import { toDate } from "date-fns";
import { action, computed, makeObservable, observable } from "mobx";
import React from "react";

export enum DateType {
  Range = "range",
  From = "from",
  Until = "until",
  None = "none",
}

export class StoreDateLimitation {
  @observable.ref
  enabled = false;

  @observable.ref
  inputFromValue = "";

  @observable.ref
  inputToValue = "";

  constructor() {
    makeObservable(this);
  }

  // @observable type = DateType.Range

  @computed get type() {
    const { end, start } = this.selectedDates;
    return !start && !end
      ? DateType.None
      : start && end
        ? DateType.Range
        : start && !end
          ? DateType.From
          : DateType.Until;
  }
  @observable month = now().getMonth();
  @observable year = now().getFullYear();
  @observable selectedDates: {
    start?: Date;
    end?: Date;
  } = {
    start: now(),
    end: now(),
  };

  @action.bound
  handleChangeInputFromValue(value: string, dateRange?: DateRange) {
    this.inputFromValue = value;
    this.selectedDates = {
      start: dateRange?.start ? toDate(dateRange.start) : undefined,
      end: this.selectedDates.end,
    };
  }

  @action.bound
  handleChangeInputToValue(value: string, dateRange?: DateRange) {
    this.inputToValue = value;
    this.selectedDates = {
      start: this.selectedDates.start,
      end: dateRange?.end ? toDate(dateRange.end) : undefined,
    };
  }

  @action.bound
  handleClear() {
    this.handleChangeInputFromValue("");
    this.handleChangeInputToValue("");
  }

  @action.bound
  handleSelectDate(date: CalendarDate | CalendarValues) {
    if (typeof date === "number" || date instanceof Date) {
      this.handleChangeInputFromValue(formatDate(toDate(date)));
      this.selectedDates = {
        start: toDate(date),
        end: undefined,
      };
      return;
    }
    this.handleChangeInputFromValue(
      date.start ? formatDate(toDate(date.start)) : "",
    );
    this.handleChangeInputToValue(date.end ? formatDate(toDate(date.end)) : "");
    this.selectedDates = {
      start: date.start ? toDate(date.start) : undefined,
      end: date.end ? toDate(date.end) : undefined,
    };
  }

  // @computed get computedType() {
  //   if (
  //     this.selectedDates.start !== this.selectedDates.end &&
  //     this.selectedDates.end &&
  //     this.selectedDates.start
  //   ) {
  //     return DateType.Range
  //   }
  //   if (!this.selectedDates.end && this.selectedDates.start) {
  //     return DateType.From
  //   }
  //   if (!this.selectedDates.start && this.selectedDates.end) {
  //     return DateType.Until
  //   }
  //   return undefined
  // }

  static create() {
    return new StoreDateLimitation();
  }
}

export const StoreDateLimitationCtx = React.createContext<StoreDateLimitation>(
  null as any as StoreDateLimitation,
);
